import React from 'react';

const shimmerDelay = (ms) => ({'--shimmer-delay': `${ms}ms`});

function GatewayClinicHoursSkeleton() {
    return (
        <div className="sms-skeleton gateway-clinic-hours-skeleton">
            {[0, 1, 2, 3, 4, 5, 6].map((i) => (
                <div
                    key={i}
                    className="gateway-clinic-hours-skeleton-item skeleton-field"
                    style={{animationDelay: `${i * 60}ms`}}
                >
                    <div className="gateway-clinic-hours-row">
                        <span
                            className="skeleton-block"
                            style={{height: 12, width: '28%', ...shimmerDelay(i * 60 + 40)}}
                        />
                        <span
                            className="skeleton-block"
                            style={{height: 12, width: '42%', ...shimmerDelay(i * 60 + 80)}}
                        />
                    </div>
                    {i % 3 === 0 && (
                        <span
                            className="skeleton-block mt-1 d-block"
                            style={{height: 10, width: '65%', ...shimmerDelay(i * 60 + 120)}}
                        />
                    )}
                </div>
            ))}
        </div>
    );
}

export default GatewayClinicHoursSkeleton;
